import QueryString from "qs";
import dynamic from "next/dynamic";
import { GetServerSideProps, NextPage } from "next";
const UseCasePage = dynamic(() => import("@/Components/pages/UseCasePage"));

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL as string;

interface ApiResponse {
  data: Array<{
    id: number;
    attributes: {
      slug: string;
      design?: string;
      [key: string]: any;
    };
  }>;
  [key: string]: any;
}

interface UseCaseDetailProps {
  apiResData: ApiResponse | null;
  slug: string;
  isNew: boolean;
}

export const getServerSideProps: GetServerSideProps<
  UseCaseDetailProps
> = async (ctx) => {
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59",
    );
  }

  const slug = "use-cases";

  let apiResData: ApiResponse | null = null;
  let isNew = false;

  const query = QueryString.stringify(
    {
      filters: {
        slug: {
          $eq: slug,
        },
      },
      populate: "deep",
    },
    {
      encodeValuesOnly: false,
    },
  );

  const apiRes = await fetch(
    `${baseUrl}use-cases?${decodeURIComponent(query)}`,
  );
  apiResData = await apiRes.json();

  isNew = apiResData?.data?.[0]?.attributes?.design === "new";

  return {
    props: {
      apiResData,
      slug,
      isNew,
    },
  };
};

const UseCaseDetail: NextPage<UseCaseDetailProps> = ({ apiResData, slug }) => {
  return (
    <div id="root">
      <div>
        <UseCasePage slug={slug} data={apiResData} />
      </div>
    </div>
  );
};

export default UseCaseDetail;
